// @ts-nocheck

import type { GlobalWidget } from '@/payload-types';

type Blocks = GlobalWidget['blocks'];

type BlockValueMap<T extends Record<string, string>> = {
  [K in keyof T]: T[K] extends Blocks[number]['blockType']
    ? Extract<Blocks[number], { blockType: T[K] }>['value']
    : never;
};

export function mapBlocksToData<T extends Record<string, string>>(
  blocks: Blocks,
  blockTypeMap: T,
): BlockValueMap<T> {
  return blocks.reduce((acc, block) => {
    const blockName = block.blockName;

    if (
      blockName && // Проверяем, что blockName существует
      blockName in blockTypeMap && // Проверяем, что blockName есть в blockTypeMap
      blockTypeMap[blockName] === block.blockType // Проверяем, что blockType совпадает
    ) {
      type BlockValue = Extract<
        Blocks[number],
        { blockType: T[typeof blockName] }
      >['value'];
      // @ts-ignore
      acc[blockName as keyof T] = block.value as BlockValue;
    }

    return acc;
  }, {} as BlockValueMap<T>);
}
/*

typescript. Предположим есть массив с объектами в котором каждый блок такого типа:
{
id: уникальный number;
value: Данные блока. Могут быть любого типа примитив или объект с определенной структурой. Тип данных строго зависит от поля blockType;
blockType: union string отображающая тип блока и определяющая тип данных поля value. К примеру может быть stringBlock | richTextBlock | mediaBlock | relationBlock.
blockName: Уникальное строковое имя. Оно не повторяется в массиве
}
Сейчас я приведу тип блоков который генерируется автоматически программой. Мы можем только задавать выбирать blockType и задавать имя блока blockName. В этом типе мы видим что тип поля blockName опциональный, и может быть null, но мы будем допускать что blockName всегда будет задан и всегда будет уникальным.
Задача - нужно написать функцию которая будет принимать массив blocks и трансформировать его в объект в котором каждый ключ будет равен уникальному blockName в массиве blocks, а значения будут содержать значение поля value соответсвующего блока. Требуется чтобы результат был строго типизированный объект, который сопоставит каждый уникальный blockName c blockType и value этого blockType.
Вот пример результата:
{uniqBlockName1: "the value whose type strictly depends on blockType", uniqBlockName2: "the value whose type strictly depends on blockType"}
*/
